import React, { memo } from 'react';
import useSetBlockState from '../../../hooks/useSetBlockState';
import type { WithBlockStateProps, WithContextProps } from '../types';

export const withBlockState = (WrappedComponent: React.ComponentType<WithContextProps>) => {
  function WithBlockStateWrapper(props: WithBlockStateProps) {
    const { block, runtimeBlockKey, ...restProps } = props;
    const { id } = block;

    const { blockState, updateBlockState, updateBlockSessionState, blockStateId } =
      useSetBlockState({
        originalBlockId: id,
        runtimeBlockKey,
      });

    return (
      <WrappedComponent
        {...restProps}
        block={block}
        blockState={blockState}
        blockStateId={blockStateId}
        updateBlockSessionState={updateBlockSessionState}
        updateBlockState={updateBlockState}
      />
    );
  }

  return memo(WithBlockStateWrapper);
};
